import { richTextToHtml } from "@dashboard/utils/richText/compat";
import { RichTextValue } from "@dashboard/utils/richText/types";
import clsx from "clsx";
import React from "react";

import useStyles from "./styles";

export interface RichTextEditorContentProps {
  className?: string;
  id?: string;
  value?: RichTextValue;
}

const RichTextEditorContent = ({ id, className, value }: RichTextEditorContentProps) => {
  const classes = useStyles({});
  const html = React.useMemo(() => richTextToHtml(value), [value]);

  return (
    <div
      id={id}
      className={clsx(classes.rootStatic, className)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

RichTextEditorContent.displayName = "RichTextEditorContent";
export default RichTextEditorContent;
